import { createSelector } from "reselect";

import type { NapiV2CartSegment } from "@app/types/napi-v2-cart-types";

import { getCartTripItem } from "./get-cart-trip-item";
import { getCartTripItemLegs } from "./get-cart-trip-item-legs";

const EMPTY_CART_SEGMENTS_ARR: NapiV2CartSegment[] = [];

/**
 * @description Equivalent of `getTripSegments`.
 * @returns the array of segments for a specific trip. As of today we always have only 1 trip per cart.
 */
export const getCartSegmentsArray = createSelector(
  [getCartTripItem],
  cart_trip_items => {
    if (!cart_trip_items) {
      return EMPTY_CART_SEGMENTS_ARR;
    }

    return cart_trip_items.segments;
  }
);

const EMPTY_CART_SEGMENT_OBJ: Record<string, NapiV2CartSegment> = {};
/**
 * @description Equivalent to `getTripsSegments`.
 * @returns all segments in the cart as an object.
 */
export const getCartSegmentsObject = createSelector(
  [getCartTripItem],
  cart_trip_item => {
    if (!cart_trip_item) {
      return EMPTY_CART_SEGMENT_OBJ;
    }

    const result: Record<string, NapiV2CartSegment> = {};
    cart_trip_item.segments.forEach(segment => {
      result[segment.id] = segment;
    });
    return result;
  }
);

const EMPTY_CART_SEGMENTS_PER_LEG: NapiV2CartSegment[][] = [];
export const getCartSegmentsPerLeg = createSelector(
  [getCartSegmentsObject, getCartTripItemLegs],
  (segments, trip_legs): NapiV2CartSegment[][] => {
    if (Object.keys(segments).length === 0 || trip_legs.length === 0) {
      return EMPTY_CART_SEGMENTS_PER_LEG;
    }

    // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    return trip_legs.map(legs => {
      if (!legs.segment_ids) {
        return [];
      }

      return legs.segment_ids.map(segment_id => segments[segment_id]);
    });
  }
);
